// Keep it sync with the backend
export const LICENSES = [
  "MIT",
  "Apache-2.0",
  "BSD-3-Clause",
  "MPL-2.0",
  "GPL-3.0-only",
  "GPL-3.0-or-later",
  "LGPL-3.0-only",
  "AGPL-3.0-only",
  "Unlicense",
  "CC0-1.0",
  "CC-BY-SA-4.0",
  "CC-BY-NC-SA-4.0",
] as const;

export type License = (typeof LICENSES)[number];

export function resolveLicenseUrl(license: License): URL {
  return new URL(`/licenses/${license}.html`, "https://spdx.org");
}
